import * as types from "../../actionTypes";

export const get = (pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_REQUEST,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_FAILURE,
    error: error
  };
};

export const remove = (id, accountType, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_REQUEST,
    id: id,
    account_type: accountType,
    pageNumber
  };
};

export const removeSuccess = data => {
  return {
    type: types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_SUCCESS,
    payLoad: data
  };
};

export const removeFailure = () => {
  return {
    type: types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_FAILURE
  };
};
